import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { conversationalWorkflowCacheKeys } from "./constants";
import type { ConversationalWorkflowResult, PutConversationalWorkflowProps } from "./types";

export const putConversationalWorkflow = reactQueryMutationAdapter(
  conversationalWorkflowCacheKeys,
  (props: PutConversationalWorkflowProps): Promise<ConversationalWorkflowResult> => {
    return fetch(`/${props.appGroupId}/conversational/workflow/${props.workflowId}`, "PUT", {
      name: props.name,
      purpose: props.purpose,
      steps: props.steps,
      chat_setting: props.chat_setting,
      messaging_channel_setting: props.messaging_channel_setting,
    });
  }
);
